import {styled, useTheme} from '@mui/material'
import {Texts} from 'appearance'
import {useI18n} from 'store/Store'

const StatsItem = ({Icon, label, value}) => {
    const theme = useTheme()
    const {i18n} = useI18n()

    return (
        <Container>
            <Icon color={theme.palette.primary.main} size={24} />
            {typeof value === 'object' ? (
                <ViewsWrapper>
                    <Label>{label}</Label>

                    <LabelWrapper>
                        <ViewsLabel>{value.views}</ViewsLabel>
                        <ViewsLabel>{i18n.t('dances.views')}</ViewsLabel>
                    </LabelWrapper>

                    <LabelWrapper>
                        <ViewsLabel>{value.pageLoads}</ViewsLabel>
                        <ViewsLabel>{i18n.t('dances.pageLoads')}</ViewsLabel>
                    </LabelWrapper>
                </ViewsWrapper>
            ) : (
                <LabelWrapper>
                    <Label>{value}</Label>
                    <Label>{label}</Label>
                </LabelWrapper>
            )}
        </Container>
    )
}

export default StatsItem

const Container = styled('div')`
    display: flex;
    align-items: start;
    gap: 12px;
`

const LabelWrapper = styled('div')`
    display: flex;
    align-items: center;
    gap: 8px;
`

const ViewsWrapper = styled('div')`
    display: flex;
    flex-direction: column;
`

const ViewsLabel = styled(Texts.Text)`
    font-size: 12px;
    font-weight: 300;
`

const Label = styled(Texts.Text)`
    font-size: 14px;
    font-weight: 600;
`
